import { api } from "./client";
import type { components } from "./types";

export type RiskIndicator = components["schemas"]["RiskIndicator"];
export type RiskType = components["schemas"]["RiskType"];
export type Severity = components["schemas"]["Severity"];

export function listRisks(opts: { includeResolved?: boolean } = {}): Promise<RiskIndicator[]> {
  const qs = opts.includeResolved ? "?include_resolved=true" : "";
  return api.get<RiskIndicator[]>(`/risks${qs}`);
}
